(() => {
  function init() {
    const containers = document.querySelectorAll('.lp-inline-recs');
    if (!containers.length) return;
    containers.forEach(el => new LpInlineRecs(el));
  }

  class LpInlineRecs {
    constructor(el) {
      this.el = el;
      this.limit = parseInt(el.dataset.limit) || 4;
      this.heading = el.dataset.heading || el.dataset.h || 'Polecane produkty';
      this.run();
    }

    async run() {
      const isAvailable = p => p.available === true || p.variants.some(v => v.available === true);
      const lp = (window.lpRecBadge || {}).localePrefix || '';

      const fetchAvailable = async (url) => {
        const res = await fetch(url);
        if (!res.ok) return [];
        const { products } = await res.json();
        return products.filter(isAvailable).slice(0, this.limit);
      };

      try {
        let available = [];

        if (this.el.dataset.collection) {
          available = await fetchAvailable(`${lp}/collections/${this.el.dataset.collection}/products.json?limit=8`);
        } else {
          for (const handle of this.detectHandles().slice(0, 3)) {
            available = await fetchAvailable(`${lp}/collections/${handle}/products.json?limit=8`);
            if (available.length) break;
          }
        }

        if (!available.length) available = await fetchAvailable(`${lp}/products.json?limit=8`);
        if (!available.length) return;
        this.render(available);
      } catch (e) {
        // fail silently
      }
    }

    detectHandles() {
      const content = document.querySelector('.article__content');
      if (!content) return [];
      const seen = new Set();
      const handles = [];
      for (const a of content.querySelectorAll('a[href*="/collections/"]')) {
        if (!(this.el.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING)) continue;
        const m = a.pathname.match(/\/collections\/([^/?#]+)/);
        if (m && m[1] !== 'all' && !seen.has(m[1])) {
          seen.add(m[1]);
          handles.push(m[1]);
        }
      }
      return handles.reverse(); // closest link first
    }

    badges(product) {
      const cfg = window.lpRecBadge || {};
      const out = [];

      if (cfg.showSale !== false) {
        const price = parseFloat(product.variants[0].price);
        const comparePrice = parseFloat(product.variants[0].compare_at_price);
        if (comparePrice && comparePrice > price) {
          let label;
          if (cfg.saleType === 'show_percentage') {
            label = '-' + Math.round((comparePrice - price) / comparePrice * 100) + '%';
          } else if (cfg.saleType === 'show_amount') {
            label = '-' + this.formatMoney(comparePrice - price);
          } else {
            label = cfg.saleLabel || 'Promocja';
          }
          out.push(`<span class="f-badge f-badge--sale" aria-hidden="true">${label}</span>`);
        }
      }

      for (const tag of (product.tags || [])) {
        if (!tag.startsWith('tag__')) continue;
        const parts = tag.slice(5).split('_');
        const type = parts[0];
        const name = parts[parts.length - 1];
        out.push(`<span class="f-badge f-badge--${type}" aria-hidden="true">${name}</span>`);
      }

      return out.length ? `<div class="product-card__badge">${out.join('')}</div>` : '';
    }

    // Renders the "Wybierz opcje" button identical to card-product.liquid's quick-add button.
    atcButton(product) {
      const cfg = window.lpRecBadge || {};
      if (!cfg.showQuickView) return '';
      const btnClass = cfg.qvBtnClass || 'btn--primary';
      const label = cfg.qvLabel || 'Wybierz opcje';
      const cartSvg = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon icon-shopping-bag icon--medium" xmlns="http://www.w3.org/2000/svg"><path d="M19.575 6.75H4.425C4.24045 6.75087 4.06254 6.81891 3.92451 6.94141C3.78648 7.06391 3.69778 7.23249 3.675 7.41562L2.34375 19.4156C2.33191 19.5202 2.34221 19.6261 2.37396 19.7264C2.40572 19.8267 2.45823 19.9192 2.52808 19.9979C2.59794 20.0766 2.68357 20.1397 2.77941 20.1831C2.87525 20.2266 2.97916 20.2494 3.08438 20.25H20.9156C21.0209 20.2494 21.1248 20.2266 21.2206 20.1831C21.3164 20.1397 21.4021 20.0766 21.4719 19.9979C21.5418 19.9192 21.5943 19.8267 21.626 19.7264C21.6578 19.6261 21.6681 19.5202 21.6563 19.4156L20.325 7.41562C20.3022 7.23249 20.2135 7.06391 20.0755 6.94141C19.9375 6.81891 19.7596 6.75087 19.575 6.75V6.75Z"/><path d="M8.25 6.75C8.25 5.75544 8.64509 4.80161 9.34835 4.09835C10.0516 3.39509 11.0054 3 12 3C12.9946 3 13.9484 3.39509 14.6517 4.09835C15.3549 4.80161 15.75 5.75544 15.75 6.75"/></svg>`;

      if (cfg.qvAction === 'product_page') {
        return `<div class="product-card__actions product-card__main-actions">
          <a href="/products/${product.handle}" class="product-card__atc product-card__action-button btn ${btnClass} no-js-hidden">
            <span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">${cartSvg}</span>
            <span class="product-card__atc-text product-card__action-text">${label}</span>
          </a>
        </div>`;
      }

      return `<div class="product-card__actions product-card__main-actions">
        <button class="product-card__atc product-card__action-button btn ${btnClass} no-js-hidden" aria-controls="lp-qv-${product.id}" aria-haspopup="dialog">
          <span class="product-card__atc-icon product-card__action-icon inline-flex md:hidden">${cartSvg}</span>
          <span class="product-card__atc-text product-card__action-text">${label}</span>
        </button>
      </div>`;
    }

    attachModals(products) {
      const cfg = window.lpRecBadge || {};
      if (!cfg.showQuickView || cfg.qvAction === 'product_page') return;

      // inject quick view CSS files once per page
      if (!window.lpQvCssInjected) {
        (cfg.qvCss || []).forEach(url => {
          if (!document.querySelector(`link[href="${url}"]`)) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            document.head.appendChild(link);
          }
        });
        window.lpQvCssInjected = true;
      }

      const closeSvg = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close icon--medium" fill="none" viewBox="0 0 24 24"><path d="M18.75 5.13496L5.25 18.8544" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.75 18.8544L5.25 5.13496" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

      products.forEach(p => {
        const id = `lp-qv-${p.id}`;
        if (document.getElementById(id)) return;
        const tpl = document.createElement('template');
        tpl.innerHTML = `<quick-view-modal id="${id}" class="quick-view drawer drawer--right" data-product-url="/products/${p.handle}" hidden><div class="fixed-overlay" aria-controls="${id}"></div><div class="drawer__inner"><button class="drawer__close-btn" aria-controls="${id}" aria-label="Zamknij">${closeSvg}</button><div class="drawer__body v-scrollable h-full quick-view__content"></div></div></quick-view-modal>`;
        document.body.appendChild(tpl.content.firstElementChild);
      });
    }

    formatMoney(price) {
      const amount = parseFloat(price);
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
      const lang = document.documentElement.lang || 'pl';
      try {
        return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(amount);
      } catch (e) {
        return price;
      }
    }

    imgUrl(src, w = 400) {
      if (!src) return '';
      return src.replace(/(\.[a-z]+)(\?|$)/i, `_${w}x$1$2`);
    }

    render(products) {
      const cards = products.map(p => {
        const img = p.images[0];
        const img2 = p.images[1];
        const hasSecond = !!img2;

        const imgTag = img
          ? `<img src="${this.imgUrl(img.src)}" alt="${(img.alt || p.title).replace(/"/g, '&quot;')}" loading="lazy" width="400" height="600">`
          : '<div class="lp-rec__img-placeholder"></div>';

        // second image: desktop-only, hidden by default, appears on hover via CSS
        const img2Tag = img2
          ? `<img class="lp-rec__img-second" src="${this.imgUrl(img2.src)}" alt="" loading="lazy" width="400" height="600">`
          : '';

        const price = this.formatMoney(p.variants[0].price);
        const comparePrice = p.variants[0].compare_at_price
          ? `<s class="lp-rec__compare-price">${this.formatMoney(p.variants[0].compare_at_price)}</s>`
          : '';

        return `<div class="lp-rec__item${hasSecond ? ' lp-rec__item--has-second' : ''}">
          <a href="/products/${p.handle}" class="lp-rec__card">
            <div class="lp-rec__img">${imgTag}${img2Tag}${this.badges(p)}${this.atcButton(p)}</div>
            <div class="lp-rec__info">
              <div class="lp-rec__title"><span class="reversed-link">${p.title}</span></div>
              <div class="lp-rec__price">${price}${comparePrice}</div>
            </div>
          </a>
        </div>`;
      }).join('');

      this.el.innerHTML = `
        <div class="lp-rec__heading">${this.heading}</div>
        <div class="lp-rec__track">${cards}</div>
      `;
      this.el.classList.add('lp-inline-recs--loaded');

      this.attachModals(products);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
